export default __webpack_public_path__ + "static/scan_audit-9728209cd6058c0ca8822a28d72b9463.gif";